<template>
  <div class="buy-credits__vue-slider">
    <vue-slider
      v-model="step"
      v-bind="options"
      :marks="sliderMarks"
      :process-style="{
        background: 'linear-gradient(90deg, #00B5FF 0%, #007EFF 100%)'
      }"
      @change="stepToCredits(step)"
    >
      <div class="buy-credits__saveindicators">
        <div
          v-for="(saveindicator, $saveindicatorIndex) in saveindicators"
          :key="$saveindicatorIndex"
          class="buy-credits__saveindicator"
        >
          <div class="buy-credits__range">
            <span>
              <span v-if="saveindicator" class="buy-credits__porcent"
                >{{ $t('buyCredits.discount') }} {{ saveindicator }}%
              </span>
            </span>
          </div>
        </div>
      </div>
    </vue-slider>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

export default {
  name: 'Slider',
  components: {
    VueSlider
  },
  props: {
    credits: { type: [String, Number], default: null }
  },
  data() {
    return {
      step: 5,
      sliderMarks: null,
      options: {
        dotSize: 32,
        width: 0,
        height: 8,
        min: 5,
        max: 100,
        interval: 5,
        duration: 0,
        dragOnClick: true,
        adsorb: true,
        tooltip: 'none',
        silent: true
      }
    };
  },
  computed: {
    ...mapState({
      creditsData: (state) => state.payments.creditsData
    }),
    saveindicators() {
      return [
        false,
        this.creditsData.firstDiscount,
        this.creditsData.secondDiscount,
        this.creditsData.thirdDiscount,
        this.creditsData.quarterDiscount,
        false
      ];
    }
  },
  watch: {
    credits: function(newVal) {
      this.setInputValue(parseInt(newVal));
    }
  },
  async created() {
    this.stepToCredits(this.step);
    const {
      startCreditsSlider,
      sectionsSlider01,
      sectionsSlider02,
      sectionsSlider03,
      sectionsSlider04,
      endCreditsSlider
    } = this.creditsData;

    this.sliderMarks = {
      '0': `${this.formatCredits(startCreditsSlider)}`,
      '20': `${this.formatCredits(sectionsSlider01)}`,
      '40': `${this.formatCredits(sectionsSlider02)}`,
      '60': `${this.formatCredits(sectionsSlider03)}`,
      '80': `${this.formatCredits(sectionsSlider04)}`,
      '100': `${this.formatCredits(endCreditsSlider)}`
    };
  },
  methods: {
    formatCredits(value) {
      const val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    sendInfoToParent(credits) {
      this.$emit('creditsData', credits);
    },
    stepToCredits(step) {
      let sliderCredits;

      switch (true) {
        case step > 0 && step <= 5:
          sliderCredits = this.creditsData.startCreditsSlider;
          break;
        case step >= 5 && step <= 10:
          sliderCredits = this.creditsData.startCreditsSlider + 990;
          break;
        case step >= 10 && step <= 25:
          sliderCredits = step * 240;
          break;
        case step >= 26 && step <= 45:
          sliderCredits = step * 210;
          break;
        case step >= 46 && step <= 65:
          sliderCredits = step * 200;
          break;
        case step >= 66 && step <= 99:
          sliderCredits = step * 750;
          break;
        case step >= 100:
          sliderCredits = step * 1200;
          break;
        default:
          sliderCredits = this.creditsData.startCreditsSlider;
      }
      this.sendInfoToParent(sliderCredits);
      this.setInputValue();
    },
    setInputValue(credits) {
      let valueSlider = 0;

      switch (true) {
        case credits >= 10 && credits < 999:
          valueSlider = 5;
          break;
        case credits >= 1000 && credits <= 3599:
          valueSlider = 10;
          break;
        case credits >= 3600 && credits <= 6299:
          valueSlider = credits / 240;
          valueSlider > 35 ? (valueSlider = 35) : credits / 240;
          break;
        case credits >= 6300 && credits <= 9999:
          valueSlider = credits / 210;
          valueSlider > 55 ? (valueSlider = 55) : credits / 210;
          break;
        case credits >= 10000 && credits <= 52499:
          valueSlider = credits / 200;
          valueSlider > 75 ? (valueSlider = 70) : credits / 200;
          break;
        case credits >= 52500 && credits <= 71249:
          valueSlider = credits / 750;
          valueSlider > 85 ? (valueSlider = 90) : credits / 750;
          break;
        case credits >= 71250 && credits <= 119999:
          valueSlider = 93;
          break;
        case credits >= 120000:
          valueSlider = 100;
          break;
        default:
          valueSlider = 0;
      }
      this.step = valueSlider;
    }
  }
};
</script>
